const Status = ({code}) => {
    if (code === 'READY') {
        return (
            <svg width="32" height="28" viewBox="0 0 41 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="40" height="31" rx="2.5" fill="#F1F6EB" />
                <rect x="0.5" y="0.5" width="40" height="31" rx="2.5" stroke="#C7DBB0" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M28.8443 9.07238C29.2186 9.44663 29.2186 10.0534 28.8443 10.4277L18.3026 20.9693C17.9284 21.3436 17.3216 21.3436 16.9474 20.9693L12.1557 16.1777C11.7814 15.8034 11.7814 15.1966 12.1557 14.8224C12.5299 14.4481 13.1367 14.4481 13.511 14.8224L17.625 18.9364L27.489 9.07238C27.8633 8.69812 28.4701 8.69812 28.8443 9.07238Z"
                    fill="#2C7800"
                />
            </svg>
        );
    }
};

export {Status};
